export default __webpack_public_path__ + "static/6-64272a581b6f5707a4aad82755e70bbd.webp";